import { throttle } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useMarkAsViewedMutation } from '../../store';
import { TrackerPromptData } from './promptsViewedContext';

const THROTTLE_DELAY = 200;

// Батчевый список промптов, которые нужно пометить просмотренными
const viewedPromptIds = new Set<number>();

/**
 * Обработчик попадания карточки на экран, который помечает ее как увиденную.
 * ID увиденных карточек копятся в батчевом списке и отправляются в ручку просмотренности.
 */
export function useMarkAsViewed() {
    const [markAsViewedMutation] = useMarkAsViewedMutation();

    const markAsViewed = useCallback(() => {
        // отправляем все накопленные id в ручку просмотренности
        markAsViewedMutation(Array.from(viewedPromptIds));

        // очищаем батч
        viewedPromptIds.clear();
    }, [markAsViewedMutation]);

    // троттлим функцию, чтобы не спамить api
    const markAsViewedThrottled = useMemo(() => throttle(markAsViewed, THROTTLE_DELAY), [markAsViewed]);

    const handleShown = useCallback(
        (entry: IntersectionObserverEntry, data?: TrackerPromptData) => {
            if (!data || !data.needMarkAsViewed) {
                return;
            }

            // добавляем id промпта в батч
            viewedPromptIds.add(data.prompt.id);

            // вызываем отправку запроса для пометки промптов просмотренными
            markAsViewedThrottled();
        },
        [markAsViewedThrottled],
    );

    return [handleShown];
}
